<template>
  <div class="page-container">
    <div >
      <div class="page_title">
        <div class="page_title_desc">老板端管理</div>
      </div>
      <el-divider></el-divider>
      <el-form :model="form" inline size="mini">
        <el-form-item >
          <el-input
            v-model="form.bossName"
            placeholder="请输入姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item >
          <el-input
            v-model="form.bossPhone"
            placeholder="请输入手机"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item >
          <el-select v-model="form.coalMineNo"
            clearable filterable placeholder="请选择煤矿">
              <el-option v-for="item in allCoalmineList" :key="item.key" :label="item.name" :value="item.code"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            perms="-1"
            label="搜索"
            icon="fa fa-search"
            size="mini"
            type="primary"
            @click="handleSearch"
          ></kt-button>
        </el-form-item>
        <el-form-item>
          <kt-button
            perms="-1"
            label="重置"
            icon="fa fa-share"
            size="mini"
            type="primary"
            @click="handleReset"
          ></kt-button>
        </el-form-item>
        <el-form-item>
          <kt-button
            perms="-1"
            label="新增"
            icon="fa fa-plus"
            size="mini"
            type="primary"
            @click="handleShowDialog('add')"
          ></kt-button>
        </el-form-item>
      </el-form>
      <el-table :data="infoList" stripe size="mini" style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="bossName"
          label="姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="bossPhone"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="coalMineName"
          label="煤矿"
          align="center"
        ></el-table-column>
        <!-- <el-table-column prop="authList" label="权限" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.authList">
              <el-tag
                v-for="item in computedAuth(scope.row)"
                :key="item.index"
                >{{ item }}</el-tag
              >
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="coalMineImage" label="首页图片" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.coalMineImage" class="img" :src="scope.row.coalMineImage" :preview-src-list="srcList" @click="handleReview(scope.row)" alt="" />
            <el-image v-else  class="img" :src="require('@/assets/logo1.png')" @click="handleReview(scope.row)"  :preview-src-list="srcList"/>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <kt-button
              perms="-1"
              label="编辑"
              size="mini"
              type="text"
              @click="handleShowDialog('edit', scope.row)"
            ></kt-button>
            <kt-button
              perms="-1"
              label="删除"
              size="mini"
              type="text"
              @click="handleDel(scope.row)"
            ></kt-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="toolbar">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;padding:10px"
      ></el-pagination>
    </div>
    </div>
    <el-dialog
      :visible.sync="showDialog"
      :title="dialogTitle"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      width="30%"
    >
      <el-form
        :model="submitForm"
        size="mini"
        label-width="80px"
        ref="submitForm"
        :rules="rulesForm"
      >
        <el-form-item label="姓名" prop="bossName">
          <el-input
            v-model="submitForm.bossName"
            :disabled="dialogTitle === '编辑'"
            clearable
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="bossPhone">
          <el-input
            v-model="submitForm.bossPhone"
            clearable
            maxlength="11"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="煤矿" prop="coalMineNo">
          <el-select v-model="submitForm.coalMineNo" clearable filterable placeholder="请选择煤矿">
            <el-option v-for="item in coalMineList" :key="item.key" :label="item.name" :value="item.code"></el-option>
          </el-select>
          <!-- <el-input
            v-model="submitForm.coalMineName"
            clearable
            placeholder="煤矿"
          ></el-input> -->
        </el-form-item>
        <!-- <el-form-item label="权限" prop="authList">
          <div>
            <el-checkbox-group v-model="submitForm.authList">
              <el-checkbox
                v-for="item in authList"
                :key="item.id"
                :label="item.id"
                :value="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item> -->
        <el-form-item label="首页图片" prop="coalMineImage">
          <upload-img
            :imageUrl="submitForm.coalMineImage"
            @setImgUrl="setDeductImgUrl"
          ></upload-img>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="cancel">取消 </el-button>
        <el-button size="mini" type="primary" @click="submitInfo" label=""
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton.vue";
import UploadImg from "@/components/Core/UploadImg.vue";
import { isMobile, isNumOrLetter } from "@/utils/validate";
export default {
  data() {
    return {
      pageNo:1,
      pageSize:10,
      totalSize:0,
      form: {},
      srcList:[],
      submitForm: {
        bossName: "",
        bossPhone: "",
        coalMineNo: "",
        coalMineImage: "",
      },
      allCoalmineList:[],
      coalMineList:[],
      uploadImgUrl: "",
      showDialog: false,
      infoList: [],
      dialogTitle: "新增",
      rulesForm: {
        bossName: [
          {
            required: true,
            message: "仅支持输入汉字，英文，数字",
          },
        ],
        bossPhone: [{ required: true, validator: this.checkbossPhone() }],
        coalMineNo: [{required:true , message:'请选择煤矿'}]
      },
    };
  },
  computed: {
    // computedAuth() {
    //   return (row) => {
    //     return row.authList.split(",");
    //   };
    // },
  },
  components: {
    KtButton,
    UploadImg,
  },
  created() {
    this.getInfoList();
    this.getAllCoalmineList();
  },
  methods: {
    cancel(){
        this.showDialog = false
        this.$refs.submitForm.resetFields()
    },
    getAllCoalmineList() {
      this.$api.finance.getAllCoalmineList().then((res) => {
        if (res.data && res.data.length > 0) {
          this.allCoalmineList = res.data;
        } else {
          this.allCoalmineList = [];
        }
      });
    },
    getInfoList() {
      let params = {
        pageNo:this.pageNo,
        pageSize:this.pageSize
      }
      let index =0
      for (let key in this.form) {
        const val = this.form[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          params["searchFieldList[" + index + "].singleValue"] = val;
          index++;
        }
      }
      this.$api.bossMgt.mGetBossList(params).then((res) => {
        this.infoList = res.data.dtoList
        this.totalSize = res.data.totalSize
      })
    },
    handleShowDialog(type, row) {
      this.dialogTitle = "新建";
      this.$api.bossMgt.mGetEnableList({
      }).then((res) => {
        this.coalMineList = res.data
      })
      if (row) {
        this.dialogTitle = "编辑";
        this.submitForm = JSON.parse(JSON.stringify(row))
      }
      this.showDialog = true;
    },
    setDeductImgUrl(url) {
      this.submitForm.coalMineImage = url;
    },
    handleSearch() {
      this.pageNo = 1
      this.getInfoList()
    },
    checkbossPhone() {
      return (rule, value, callback) => {
        if (!value) {
          return callback(new Error("请输入手机号"));
        }
        if (!isMobile(value)) {
          return callback(new Error("输入正确手机号格式"));
        }
        return callback();
      };
    },
    handleReset() {
      this.form ={}
      this.handleSearch()
    },
    handleEdit(row) {
      this.showDialog = true;
    },
    handleReview(row){
      this.srcList = []
      this.srcList.push(row.coalMineImage||'https://ejiyun.obs.cn-north-4.myhuaweicloud.com/test/base/image/202112/61a6e9aca00c687b379f4204.png')
    },
    handleDel(row) {
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(async(confirm) => {
          let res = await this.$api.bossMgt.deleteBoss({
            bossNo:row.bossNo
          })
          this.$message({
            type:'success',
            message:'删除成功',
            offset:300
          })
          this.getInfoList();
        })
        .catch((err) => {});
    },
    dialogCloseCallback() {
      this.$refs.submitForm.resetFields();
      this.dialogTitle = "";
    },
    refreshPageRequest(val){
      this.pageNo = val
      this.getInfoList()
    },
    submitInfo() {
      let action =  this.dialogTitle==='新建'  ? 'createBossInfo' :'editBossInfo'
      this.$refs.submitForm.validate((valid) => {
        if(valid){
          this.$api.bossMgt[action]({
            ...this.submitForm,
            coalMineName:this.coalMineList.find(i=>{return i.code == this.submitForm.coalMineNo})['name']
          }).then((res) => {
            this.$message({
              message:'提交成功',
              type:'success',
              offset:300
            })
            this.showDialog =false
            this.getInfoList()
          })
        }

      })
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.img{
  width: 100%;
  height: 100%;
  display: block;
}
</style>